const r = {
  id: "MassachusettsKeno",
  logo: !0,
  name: "Keno",
  style: {
    colorAccent: "#fccf07",
    colorPrimary: "#0f133c",
    highFrequency: {
      backButtonColor: "var(--color-text-primary-primary-inverted)",
      ball: {
        background: "radial-gradient(50% 50% at 50% 50%, #feed93 0%, #fece00 100%)",
        highlight: "0 0 1.75rem 0 #fdd454",
        selected: {
          background: "#0f133e",
          borderColor: "#1952e0",
          textColor: "var(--color-text-primary-primary-inverted)"
        },
        shadow: "linear-gradient(90deg, rgb(0, 0, 0, 0%) 0%, #000 50%, rgb(0, 0, 0, 0%) 100%)",
        textColor: "#000"
      },
      bonus: {
        gameCardText: "#037c8d",
        headline: "#49c2d3",
        multiplier: "#49c2d3"
      },
      colorPrimaryAccent: "#1952E0",
      nextDraw: {
        background: "radial-gradient(124.84% 92% at 49.13% 23.21%, rgba(40, 50, 164, 0.00) 0%, rgba(15, 19, 62, 0.80) 100%)",
        backgroundColor: "#151a55",
        cardBorderColor: "#1952e0",
        notOperating: {
          cardBackground: "linear-gradient(99deg, rgb(15, 19, 62, 40%) -1.52%, #0f133e 92.42%)",
          numberColor: "var(--color-lightblue-900)"
        },
        pending: {
          cardBackground: "linear-gradient(270deg, var(--color-transparent-blue-60-950, rgba(89, 94, 153, 0.60)) 0%, var(--color-transparent-blue-60-800, rgba(132, 162, 219, 0.60)) 100%)",
          numberColor: "var(--color-text-primary-primary-inverted)",
          progressbarColor: "linear-gradient(99deg, rgb(15, 19, 62, 70%) -1.52%, #0f133e 92.42%)"
        },
        ready: {
          cardBackground: "linear-gradient(99deg, rgb(15, 19, 62, 40%) -1.52%, #0f133e 92.42%)",
          numberColor: "#fbcd0c"
        },
        textColor: "var(--color-text-primary-primary-inverted)"
      },
      order: {
        background: "linear-gradient(180deg, #1852e1 5rem, #0f133c 20rem, #0f133c 35rem, rgba(15, 19, 60, 0) 100%)",
        backgroundColor: "#060871",
        topSection: {
          gradient: "radial-gradient(45.73% 50% at 50% 52%, rgb(15 19 60 / 0) 0%, rgb(15 19 60 / 0.6) 48.05%, rgb(15 19 60 / 0.95) 100%)",
          textColor: {
            primary: "#fff",
            secondary: "#595e99"
          }
        }
      },
      results: {
        backgroundColor: "#080A64",
        bottomGradient: "linear-gradient(90deg, rgba(32, 65, 175, 0.8) 0%, rgba(15, 19, 60, 0.8) 100%)",
        bottomText: "var(--color-text-primary-primary-inverted)"
      },
      teaser: {
        backgroundColor: "#060871",
        backgroundGradient: "radial-gradient(50% 62.76% at 50% 52.02%, rgb(15, 19, 60, 0%) 0%, rgb(15, 19, 60, 60%) 60.1%, rgb(15, 19, 60, 95%) 100%)",
        jackpotColor: "#fccf07",
        logoColor: "#fccf07",
        textColor: "var(--color-text-primary-primary-inverted)",
        watch: {
          backgroundGradient: "linear-gradient(180deg, #2041AF 45.24%, #0F133C 99.65%)",
          badge: {
            background: "#0F133C",
            borderColor: "#2041AF",
            gameColor: "#FCCF07",
            textColor: "#FFFFFF"
          },
          footerColor: "#FFFFFF",
          gameBackgroundGradient: "radial-gradient(47.98% 49.26% at 50% 55.93%, rgba(15, 19, 62, 0) 0%, #0F133E 100%)",
          icon: {
            arrowsColor: "#FFFFFF",
            arrowsColorFade: "#0F133C",
            pauseColor: "#FFFFFF",
            timerColor: "#FFFFFF"
          },
          newGameColor: "#FCCF07",
          play: {
            colorEnd: "#fbcd0c",
            colorStart: "#fff5c9",
            dropShadowColor: "rgb(0, 0, 0, 27%)",
            shadowColor: "#d3a700"
          },
          titleColor: "#FCCF07"
        }
      },
      watchMode: {
        background: "linear-gradient(180deg, #2041AF 0%, var(--color-ma-keno-primary, #0f133c) 33.74%)",
        badge: {
          background: "linear-gradient(99deg, rgb(15, 19, 62, 40%) -1.52%, #0f133e 92.42%)",
          borderColor: "#1952e0",
          gameColor: "#fbcd0c",
          textColor: "#fff"
        },
        bonusColor: "#49c2d3",
        bonusEffectColor: "#fbcd0c",
        main: {
          background: "rgba(21, 26, 85, 0.8980392157) radial-gradient(48.02% 77.4% at 50% 46.16%, rgba(40, 50, 164, 0.4) 0%, rgba(15, 19, 62, 0.9) 100%)",
          card: {
            background: "#151a55",
            borderColor: "rgba(25, 82, 224, 0.4)"
          }
        },
        textColor: "var(--color-text-primary-primary-inverted)"
      }
    }
  }
};
export {
  r as default
};
